import React from "react";

//MUI
import SvgIcon from '@mui/material/SvgIcon';

//Types
import { SvgIconProps } from "@mui/material";

interface IRullerOffIcon extends SvgIconProps {
  iconColor?: string;
}

function RullerOffIcon({ iconColor = "#FFFFFF", ...props }: IRullerOffIcon) {
  return <SvgIcon {...props}>
    <svg version="1.1" id="RullerOffIcon" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
      width="24px" height="24px" viewBox="0 0 24 24"
      style={{
        //@ts-ignore
        enableBackground: "new 0 0 24 24"
      }} xmlSpace="preserve">
      <polygon fill={iconColor} points="10.464,6.816 12.473,8.826 15.697,8.826 15.697,12.161 17.706,12.161 17.706,8.826 20.72,8.826
	20.72,15.174 18.822,15.174 20.831,17.184 22.729,17.184 22.729,6.816"/>
      <path fill={iconColor} d="M9.61,8.826L7.601,6.816h0L3.182,2.398L1.751,3.83l2.987,2.987H1.271v10.367h13.833l5.13,5.13l1.432-1.432
	L9.61,8.826L9.61,8.826z M3.28,15.174V8.826h3.014v3.335h2.009v-1.779l4.792,4.792H3.28z"/>
    </svg>
  </SvgIcon>
}

export default RullerOffIcon;
